import * as React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { withLocalize } from 'react-localize-redux';
import { useDispatch, useSelector } from 'react-redux';

import {
    IconButton,
} from '@material-ui/core';
import { programLanguages } from '../constants';
import * as AuthStore from '../../app/store/AuthStore';
import { storeLanguagePreferance } from '../../app/localization';

const styles = () => ({
    root: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        opacity: '0.8',
    },
});

const LanguageToggle = ({
    activeLanguage, setActiveLanguage, classes,
}) => {
    const dispatch = useDispatch();
    const appConfig = useSelector(state => state.pageSettings.appConfig);

    const selectLanguage = languageCode => () => {
        if (languageCode !== activeLanguage.code) {
            setActiveLanguage(languageCode);
            storeLanguagePreferance(languageCode);

            const programId = appConfig?.startProgram?.[languageCode];
            if (programId) {
                dispatch(AuthStore.actionCreators.startNewSession({
                    orgId: appConfig?.orgId,
                    programId,
                    programStartDate: new Date(),
                    includeCurrentProgramInResponse: true,
                }, { useSessionWithoutLifetime: true }));
            }
        }
    }

    return (
        <div className={classes.root}>
            {programLanguages.map(lang => (
                <IconButton
                    key={lang.code}
                    onClick={selectLanguage(lang.code)}
                    color={lang.code === activeLanguage.code ? 'primary' : 'default'}
                >
                    {lang.code}
                </IconButton>
            ))}
        </div>
    );
};

LanguageToggle.propTypes = {
    classes: PropTypes.object.isRequired,
    // languages: PropTypes.array.isRequired, // available languages from react-redux-translate
    activeLanguage: PropTypes.object,
    setActiveLanguage: PropTypes.func.isRequired,
};

LanguageToggle.defaultProps = {
    activeLanguage: {},
};

export default withLocalize(withStyles(styles)(LanguageToggle));
